/**
 * @file
 * Placeholder file for custom sub-theme behaviors.
 *
 */
(function ($, Drupal) {
  'use strict';

  /* global Foundation */

  Drupal.behaviors.mainMenuNavigation = {
    attach: function (context, settings) {
      $('.main-navigation .menu > .menu-item > a.menu-link').on('focus', function(){
        $('.main-navigation .menu > .menu-item .menu-dropdown').removeClass('tab-hover');
        $(this).parent().find('.menu-dropdown').addClass('tab-hover');
      });

      $('body').on('click', function () {
        $('.main-navigation .menu > .menu-item .menu-dropdown').removeClass('tab-hover');
      });
    }
  };

  Drupal.behaviors.mobileNavigation = {
    attach: function (context, settings) {

      $('.menu-dropdown-link').click(function (e) {
        e.preventDefault();
        $(this).next('.menu-dropdown').toggleClass('expand');
        $(this).toggleClass('dropdown-open');
      });

      $('.mobile-menu-toggler').on('click', function (e) {
        e.preventDefault();
        $(this).toggleClass('open');
        $('.l-header .mobile-header-actions-container').toggleClass('open');
        $('.l-header .main-navigation').toggleClass('open');
        $('.l-header').toggleClass('open');
      });

      $('.mobile-sub-menu-toggler').on('click', function (e) {
        e.preventDefault();
        $(this).toggleClass('open');
        $('.sub-navigation').toggleClass('open');
      });

      $(window).on('changed.zf.mediaquery', function (event, newSize, oldSize) {
        if (newSize === 'xlarge' && oldSize === 'large') {
          $('.l-header').removeClass('open');
          $('.mobile-menu-toggler').removeClass('open');
          $('.l-header .header-actions-container').removeClass('open');
          $('.l-header .main-navigation').removeClass('open');
        }

      });

    }
  };

  Drupal.behaviors.stickyNavigation = {

    attach: function (context, settings) {
      var previousScroll = 0;
      var $header = $('.l-header');
      var headerHeight = $header.height();
      var bodyTopPadding = $('body').css('padding-top');
      var $page = $('.l-page');
      $(window).scroll(function () {
        if (!($header.find('.main-navigation').hasClass('open'))) {
          headerHeight = $header.height();
          bodyTopPadding = $('body').css('padding-top');
          var currentScroll = $(this).scrollTop();
          if (currentScroll > headerHeight / 2) {
            if (currentScroll > previousScroll) {
              $header.css('top', '-' + headerHeight + 'px');
            }
            else {
              $header.css('top', bodyTopPadding);
              $header.addClass('fixed');
              $page.css('padding-top', bodyTopPadding + headerHeight);
            }
          }
          else {
            $header.removeClass('fixed');
            $page.css('padding-top', bodyTopPadding + headerHeight);
          }
          previousScroll = currentScroll;
        }

      });
    }


  };

  Drupal.behaviors.responsiveTable = {
    attach: function (context, settings) {
      $('.field-node--body table').wrap('<div class="table-container table-scroll"></div>');
    }
  };
  Drupal.behaviors.searchFilterToggler = {
    attach: function (context, settings) {
      $('#search-filters-toggler').on('click', function () {
        $(this).toggleClass('open');
        $('.search-filters-container').toggleClass('open');
      });
    }
  };
  Drupal.behaviors.searchSorting = {
    attach: function (context, settings) {
      var $sView = $('.view-id-search');
      if ($sView.length > 0) {
        $sView.find('.view-content').prepend($sView.find('.sorting-options-container'));

        if($sView.find('.view-empty').length < 1) {
          $sView.find('.sorting-options-container').removeClass('hidden');

          $sView.find('.selected-sorting-option').on('click', function () {
            $sView.find('.sorting-options').toggleClass('hidden');
          });
        }

        $sView.find('.sorting-option-selector').on('click', function (e) {
          e.preventDefault();
          var optionType = $(this).data('option-type');
          var optionOrder = $(this).data('option-order');
          $sView.find('#edit-sort-by').val(optionType);
          $sView.find('#edit-sort-order').val(optionOrder);
          $sView.find('.views-exposed-form').submit();
        });
      }
    }
  };

  Drupal.behaviors.publicationsListingSorting = {
    attach: function (context, settings) {
      var $pView = $('.view-publications-listing');
      if ($pView.length > 0) {

        if($pView.find('.view-content').length) {
          $pView.find('.view-content').prepend($pView.find('.sorting-options-container'));
          $pView.find('.sorting-options-container').removeClass('hidden');

          $pView.find('.selected-sorting-option').on('click', function () {
            $pView.find('.sorting-options').toggleClass('hidden');
          });
        }

        $pView.find('.sorting-option-selector').on('click', function (e) {
          e.preventDefault();
          var optionType = $(this).data('option-type');
          var optionOrder = $(this).data('option-order');
          $pView.find('#edit-sort-by').val(optionType);
          $pView.find('#edit-sort-order').val(optionOrder);
          $pView.find('.views-exposed-form').submit();
        });
      }
    }
  };

  Drupal.behaviors.contractNavigation = {
    attach: function (context, settings) {
      $('.accordion-child-toggler').each(function () {
        $(this).parent().removeClass('is-accordion-submenu-parent');
      });
      $('a.not-container').on('click', function (e) {
        var url = $(this).attr('href');
        $(this).siblings('.menu').css('display', 'none');
        window.location.href = url;
      });
      $('.accordion-child-toggler').on('click', function () {
        $(this).toggleClass('open');
      });

    }
  };

  Drupal.behaviors.dataTableBehavior = {
    attach: function (context, settings) {
      $(context).find('[id^=example]').addClass('processed');
      $('[id^=tocid]').on('click', function (e) {
        var NodeId = $(this).attr('id').match("tocid_(.*)#")[1];
        var RowNum = $(this).attr('id').replace('tocid_' + NodeId + '#', '');
        var tableSelector = 'table#example_' + NodeId + '> tbody > tr:eq(' + (RowNum) + ')';
        var row = $( tableSelector );
        var offset = row.offset();
        $('.dataTables_scrollBody').animate({scrollTop: (row.offset().top - ($('#example_' + NodeId ).offset().top))}, 1000);
      });

      $('[id^=example]').DataTable({
        "paging": settings.paging,
        "ordering": settings.ordering,
        "info": settings.info,
        "scrollY": settings.scrollY,
        "oLanguage": {
          "sSearch": settings.searchLabel
        }
      });
    }
  };

  Drupal.behaviors.heroModalBehavior = {
    attach: function (context, settings) {
      $('.hero-modal-toggler').on('click', function (e) {
        e.preventDefault();
        var modalContent = $(this).parent().find('.field-paragraph--field-modal-content');
        var modalTargetId = $(this).data('open');
        if ($('#' + modalTargetId).length < 1) {
          var modal = document.createElement('div');
          $(modal).attr('id', modalTargetId);
          $(modal).attr('data-reveal', '');
          $(modal).attr('data-animation-in', 'slide-in-down fast');
          $(modal).attr('data-animation-out', 'slide-out-up fast');
          $(modal).attr('data-reset-on-close', 'true');
          $(modal).addClass('reveal');
          $(modal).addClass('large');
          $(modal).append('<button class="close-button" data-close aria-label="Close modal" type="button"><span aria-hidden="true">&times;</span></button>');
          $('body').append(modal);

          new Foundation.Reveal($(modal));
          $(modal).append($(modalContent).html());
        }
      });
    }

  };

  // Adds a quicklink class to parent container for different colors in mobile
  Drupal.behaviors.quicklinksBehavior = {
    attach: function (context, settings) {
      var quickLinksList = $('ul.quick-links');
      if (quickLinksList.length > 0) {
        quickLinksList.parents('.paragraph--type--simple-text').parent('.field-item').addClass('quick-links-container');
      }
    }
  };

  Drupal.behaviors.switchLanguageBlock = {
    attach: function (context, settings) {
      var switchLanguageElement = $('#block-kt-new-switchcurrentlanguage');
      if (switchLanguageElement.length > 0) {
        if (switchLanguageElement.parents('.node--type-landing-page').length > 0) {
          $('#block-kt-new-breadcrumbs .breadcrumbs-container').append(switchLanguageElement);
        }
      }
    }
  };

  Drupal.behaviors.heroContentInnerPadding = {
    attach: function (context, settings) {
      $( window ).on('load resize', function () {
        var heroContentInner = $('.paragraph--type--hero .hero-container .hero-content > .row .hero-content-inner');
        if (heroContentInner.length > 0) {
          heroContentInner.each( function() {
            if ($(window).width() < 768) {
               $(this).parents('.paragraph--type--hero').css('margin-bottom',  $(this).height() + 50);
            }
            else {
              if ( $(this).parents('.paragraph--type--hero').parent('.field-item').next().length > 0) {
                 $(this).parents('.paragraph--type--hero').css('margin-bottom', '3.6rem');
              } else {
                 $(this).parents('.paragraph--type--hero').css('margin-bottom', '0');
              }
            }
          });
        }
      });
    }
  };

  Drupal.behaviors.upcomingEventBlock = {
    attach: function (context, settings) {
      var upcomingEventElement = $('.view-id-upcoming_events');
      if (upcomingEventElement.length > 0) {
        upcomingEventElement.parents('.paragraph--type--automated-liftup').addClass('upcoming-event-container');
      }
    }
  };

  Drupal.behaviors.faqInstructionBlock = {
    attach: function (context, settings) {
      var faqBlock = $('.view-display-id-thematic_liftup_grid');
      if (faqBlock.length > 0) {
        faqBlock.parents('.paragraph--type--automated-liftup').addClass('faq-instruction-container');
      }
    }
  };

    Drupal.behaviors.viewMagazineArticles = {
      attach: function (context, settings) {
        var magazineArticles = $('.view-id-magazine_articles');
        if (magazineArticles.length > 0) {
          magazineArticles.parent('.views-element-container').prev('.thematic-liftup-heading').addClass('magazine_articles__header');
          magazineArticles.parents('.paragraph--type--automated-liftup').addClass('magazine-articles-square__container');
        }
      }
    };

    Drupal.behaviors.viewThematicLiftupCard = {
      attach: function (context, settings) {
        var thematicLiftupCard = $('.view-mode-thematic_liftup_card_medium');
        if (thematicLiftupCard.length > 0) {
          thematicLiftupCard.parents('.paragraph--type--automated-liftup').parent('.field-item').addClass('blog-card-medium-container');
          thematicLiftupCard.parents('.section-content').css('overflow', 'visible');
        }
      }
    };

  // Show more related content
  Drupal.behaviors.showMoreRelated = {
    attach: function (context, settings) {
      var relatedContentView = $('.view-related-content.view-display-id-related_content_v2, .view-magazine-articles.view-display-id-magazine_article_card_square');
      if($(relatedContentView).length > 0) {
        var viewContent = $(relatedContentView).children('.view-content');

        if($(viewContent).length > 0) {

          // Show first 3 items
          var rowItemCount = 3;
          if(relatedContentView.hasClass('view-display-id-magazine_article_card_square')) {
            rowItemCount = 4;
          }
          $(viewContent).children('.views-row:lt(' + rowItemCount + ')').show();

          // Count number of nodes
          var rowCount = $(viewContent).children('.views-row').length;
          if(rowCount > rowItemCount) {
            // Show load more button
            $(viewContent).children('.load-more').show();
          }

          $('#show-more-related').on('click', function (e) {
            e.preventDefault();
            $(viewContent).children('.views-row').not(':visible').slideDown();
            $(this).hide();
          });

        }

      }

    }

  };

  // Show more related content
  Drupal.behaviors.showMoreNews = {
    attach: function (context, settings) {
      var relatedNewsView = $('.view-related-content.view-display-id-publication_related_news, .view-related-content.view-display-id-related_news_v2');
      if($(relatedNewsView).length > 0) {
        var viewContent = $(relatedNewsView).children('.view-content');

        if($(viewContent).length > 0) {

          // Show first 3 items
          $(viewContent).children('.views-row:lt(3)').show();

          // Count number of nodes
          var rowCount = $(viewContent).children('.views-row').length;
          if(rowCount > 3) {
            // Show load more button
            $(viewContent).children('.load-more').show();
          }

          $('#show-more-related').on('click', function (e) {
            e.preventDefault();
            $(viewContent).children('.views-row').not(':visible').slideDown();
            $(this).hide();
          });

        }

      }

    }

  };

  Drupal.behaviors.webFormError = {
    attach: function (context, settings) {
      $('.webform-submission-form .error').each(function (){
        var $label = $($(this).parents('.form-item').find('label'));
        if ($label.length > 0) {
          $label.addClass('error');
        }
      });
    }
  };

  Drupal.behaviors.highChartsOptions = {
    attach: function(context, settings) {
      if(typeof Highcharts !== 'undefined') {
          Highcharts.setOptions({
              lang: {
                  decimalPoint: ','
              }
          });
      }
    }
  };

  Drupal.behaviors.searchBlockAccordion = {
    attach: function(context, settings) {
      $('#view-results').css('display','block');
      $('#search-results-toggler').unbind('click').on('click', function(e){
        if($('#view-results').css('display') == 'block') {
            $('#view-results').css('display','none');
            $('#search-accordion-item').removeClass('is-active');
        } else {
            $('#view-results').css('display','block');
            $('#search-accordion-item').addClass('is-active');
        }
      });
    }
  };

  Drupal.behaviors.shareButtons = {
    attach: function(context, settings) {
      var $shareButtonsBlock = $('.bottom-actions-container');
      if($('.listing-page').length > 0) {
        // We are on a listing page
        var $listingView = $('.listing-page');
        $listingView.after($shareButtonsBlock);
        $shareButtonsBlock.css('border-bottom', '0');
        $shareButtonsBlock.removeClass('hidden');
      } else {
        $shareButtonsBlock.removeClass('hidden');
      }
    }
  };

  /**
   * Trainings Finder widget
   */
  Drupal.behaviors.trainingsFinderWidget = {
    attach: function (context, settings) {
      var $widget = $('#fcg-widget-trainings-finder');

      if($widget.length > 0) {

        // Profession autocomplete
        var getProfsURL = "https://apps.kuntaliitto.fi/kt/getProfs.php";
        $('#fcg-widget-trainings-finder #prof', context).autocomplete({
          minLength: 3,
          source: function( request, response ) {
            $.getJSON(getProfsURL, {q: request.term })
                .done(function(data) {
                  response( data );
                });
          }
        });

        // Training search
        $widget.find("#training-finder-form-submit").on('click', function (e) {
          var profValue = $widget.find('#prof').val();
          var getTrainingsURL = "https://apps.kuntaliitto.fi/kt/list-edu-json.php";

          $.getJSON(getTrainingsURL, {prof: profValue })
              .done(function(deg) {
                var output = "<table class='fcg-embedded-table'>";
                for (var i in deg) {
                  output=output + "<tr class='fcg-embedded-table-row'><td>" +deg[i].degree_name + "</td><td>(" + deg[i].pd_count + " kappaletta)</td></tr>";
                }
                output=output + "</table>";
                $("#prof-degree-area").html(output);

              });


          e.preventDefault();
        });

      }
    }
  };

  /**
   * Degree Profession widget
   */
  Drupal.behaviors.degreeProfessionWidget = {
    attach: function (context, settings) {
      var $widget = $('#fcg-widget-degree-profession');

      if($widget.length > 0) {

        // Degree autocomplete
        var getDegreesURL = "https://apps.kuntaliitto.fi/kt/getDegrees.php";
        $('#fcg-widget-degree-profession #educ', context).autocomplete({
          minLength: 3,
          source: function( request, response ) {
            $.getJSON(getDegreesURL, {q: request.term })
                .done(function(data) {
                  response( data );
                });
          }
        });

        // Training search
        $widget.find("#degree-profession-form-submit").on('click', function (e) {
          var educValue = $widget.find('#educ').val();
          var getDegreesURL = "https://apps.kuntaliitto.fi/kt/list-prof-json.php";

          $.getJSON(getDegreesURL, {educ: educValue })
              .done(function(deg) {
                var output = "<table class='fcg-embedded-table'><tr class='fcg-embedded-table-header'><th>Ammattinimikkeet</th><th>Lukumäärä</th></tr>";
                for (var i in deg) {
                  output=output + "<tr class='fcg-embedded-table-row'><td>" +deg[i].profession_name + "</td><td>" + (deg[i].pd_count).toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1 ") + "</td></tr>";
                }
                output=output + "</table>";
                $('.letterchain-letter.active').removeClass('active');
                $("#degree-profession-area").html(output);
                $("#degrees-by-letter").hide();
                $("#degree-profession-area").show();

              });


          e.preventDefault();
        });

        var $letterchain = $widget.find('#letterchain');

        if($letterchain.length > 0) {
          var getProfessionLettersURL = "https://apps.kuntaliitto.fi/kt/getDegreeLetters.php";

          $.getJSON(getProfessionLettersURL)
              .done(function(letters) {
                var letterChain = "";
                for(var key in letters) {
                  var value = letters[key];
                  letterChain = letterChain + "<a class='letterchain-letter' title='" + value+ "' data-letter='"+ key +"'>" + key + "</a> ";
                }
                $letterchain.html(letterChain);

              });


          // Find lettered
          $letterchain.on('click', '.letterchain-letter', function (e){
            var getDegreeByLetterURL = "https://apps.kuntaliitto.fi/kt/getDegreesByLetter.php";
            var letter = $(this).data("letter");
            $('.letterchain-letter.active').removeClass('active');
            $(this).addClass('active');

            $.getJSON(getDegreeByLetterURL, {q: letter })
                .done(function(educs) {
                  var educlink = "<h4>Tutkinnot</h4>";
                  for(var educ in educs) {
                    var value = educs[educ];
                    educlink = educlink + "<a class='educlink' data-educ='"+ value +"'>" + value + "</a>";
                  }
                  $("#degrees-by-letter").html(educlink);
                  $("#degrees-by-letter").show();
                  $("#degree-profession-area").hide();
                });


            e.preventDefault();
          });


          // Invoke search
          $('#degrees-by-letter').on('click', '.educlink', function (e){
            var educValue = $(this).data("educ");

            var getTrainingsURL = "https://apps.kuntaliitto.fi/kt/list-prof-json.php";

            $.getJSON(getTrainingsURL, {educ: educValue })
                .done(function(deg) {
                  var output = "<h3>" + educValue + "</h3>";
                  output += "<table class='fcg-embedded-table'><tr class='fcg-embedded-table-header'><th>Ammattinimikkeet</th><th>Lukumäärä</th></tr>";
                  for (var i in deg) {
                    output=output + "<tr class='fcg-embedded-table-row'><td>" +deg[i].profession_name + "</td><td>" + (deg[i].pd_count).toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1 ") + "</td></tr>";
                  }
                  output +=  "</table>";
                  $("#degree-profession-area").html(output);
                  $('.letterchain-letter.active').removeClass('active');
                  $("#degrees-by-letter").hide();
                  $("#degree-profession-area").show();
                });


            e.preventDefault();
          });


        }

      }
    }
  };


  /**
   * Prof Degrees widget
   */
  Drupal.behaviors.profDegreeWidget = {
    attach: function (context, settings) {
      var $widget = $('#fcg-widget-prof-degrees');

      if($widget.length > 0) {

        // Profession autocomplete
        var getProfsURL = "https://apps.kuntaliitto.fi/kt/getProfs.php";
        $('#fcg-widget-prof-degrees #prof', context).autocomplete({
          minLength: 3,
          source: function( request, response ) {
            $.getJSON(getProfsURL, {q: request.term })
                .done(function(data) {
                  response( data );
                });
          }
        });


        $widget.find("#prof-degrees-form-submit").on('click', function (e) {
          var profValue = $widget.find('#prof').val();
          var getDegreesURL = "https://apps.kuntaliitto.fi/kt/list-edu-json.php";

          $.getJSON(getDegreesURL, {prof: profValue })
              .done(function(deg) {
                var output = "<h3>" + profValue + "</h3>";
                output += "<table class='fcg-embedded-table'><tr class='fcg-embedded-table-header'><th>Tutkinnot</th><th>Lukumäärä</th></tr>";
                for (var i in deg) {
                  output += "<tr class='fcg-embedded-table-row'><td>" + deg[i].degree_name + "</td><td>" + (deg[i].pd_count).toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1 ") + "</td></tr>";
                }
                output += "</table>";
                $('.letterchain-letter.active').removeClass('active');
                $("#prof-degrees-area").html(output);
                $("#profs-by-letter").hide();
                $("#prof-degrees-area").show();

              });

          e.preventDefault();
        });

        // Get Profession letters
        var $letterchain = $widget.find('#letterchain');

        if($letterchain.length > 0) {
          var getProfessionLettersURL = "https://apps.kuntaliitto.fi/kt/getProfessionLetters.php";

          $.getJSON(getProfessionLettersURL)
              .done(function(letters) {
                var letterChain = "";
                for(var key in letters) {
                  var value = letters[key];
                  letterChain = letterChain + "<a class='letterchain-letter' title='" + value+ "' data-letter='"+ key +"'>" + key + "</a> ";
                }
                $letterchain.html(letterChain);

              });


          // Find lettered
          $letterchain.on('click', '.letterchain-letter', function (e){
            var getProfessionsByLetterURL = "https://apps.kuntaliitto.fi/kt/getProfessionsByLetter.php";
            var letter = $(this).data("letter");
            $('.letterchain-letter.active').removeClass('active');
            $(this).addClass('active');

            $.getJSON(getProfessionsByLetterURL, {q: letter })
                .done(function(profs) {
                  var proflink = "<h4>Ammattinimikkeet</h4>";
                  for(var prof in profs) {
                    var value = profs[prof];
                    proflink = proflink + "<a class='proflink' data-prof='"+ value +"'>" + value + "</a>";
                  }
                  $("#profs-by-letter").html(proflink);
                  $("#profs-by-letter").show();
                  $("#prof-degrees-area").hide();
                });


            e.preventDefault();
          });


          // Invoke search
          $('#profs-by-letter').on('click', '.proflink', function (e){
            var profS = $(this).data("prof");

            var getTrainingsURL = "https://apps.kuntaliitto.fi/kt/list-edu-json.php";

            $.getJSON(getTrainingsURL, {prof: profS })
                .done(function(deg) {
                  var output = "<h3>" + profS + "</h3>";
                  output += "<table class='fcg-embedded-table'><tr class='fcg-embedded-table-header'><th>Tutkinnot</th><th>Lukumäärä</th></tr>";
                  for (var i in deg) {
                    output += "<tr class='fcg-embedded-table-row'><td>" + deg[i].degree_name + "</td><td>" + (deg[i].pd_count).toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1 ") + "</td></tr>";
                  }
                  output +=  "</table>";
                  $("#prof-degrees-area").html(output);
                  $('.letterchain-letter.active').removeClass('active');
                  $("#profs-by-letter").hide();
                  $("#prof-degrees-area").show();
                });


            e.preventDefault();
          });


        }



      }

    }
  };


  /**
   * Use this behavior as a template for custom Javascript.
   */
  Drupal.behaviors.exampleBehavior = {
    attach: function (context, settings) {
      // alert("I'm alive!");
    }
  };

})(jQuery, Drupal);
